import {text_mod_47, } from "../text/Text.js";
export const module47 = {
  title:
    "§47. Добір питань до дієслів",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_47, },
    ]
  }
